import { nextTick } from "vue";

export async function startViewTransition(callback: () => unknown) {
    if (document.startViewTransition) {
        const transition = document.startViewTransition(async () => {
            callback();
            await nextTick();
        });

        await transition.finished;
    } else {
        callback();
    }
}
